import { UIComponentProps, UIComponentHandler, UIComponentState, UIDataModel, UIComponentImpl } from '../../uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { UIComponentView } from '../../uicomponentview';
import { SearchBoxViewImpl } from './searchboxview';
import { SearchBoxCSSStyle, SearchBoxCSSStyleImpl } from './searchboxcss';

export interface SearchBoxComponentProps extends UIComponentProps
{
    searchKey: string;
    cssStyle:SearchBoxCSSStyle;
    onSearchBoxButtonClicked(searchKey: string):void;
}

export interface SearchBoxComponentHandler extends UIComponentHandler
{
    onSearchBoxButtonClicked(searchKey: string):void;
    onChange(value: string): void;
    clearData():void;
}

export interface SearchBoxComponentState extends UIComponentState
{
    searchKey: string;
}

export class SearchBoxComponent extends UIComponentImpl<SearchBoxComponentProps, UIComponentState, UIDataModel> implements SearchBoxComponentHandler
{
    constructor(props: SearchBoxComponentProps)
    {
        super(props);

        this.state = {searchKey: props.searchKey};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new SearchBoxViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SearchBoxCSSStyleImpl(applicationContext);
    }

    componentWillReceiveProps(nextProps: SearchBoxComponentProps)
    {
        this.setState({searchKey: nextProps.searchKey});
    }

    onSearchBoxButtonClicked(searchKey: string): void 
    {
        this.props.onSearchBoxButtonClicked(searchKey);
    }   

    onChange(value: string): void {
        this.setState({searchKey: value});
    }
    clearData():void
    {
        this.setState({searchKey:""});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/searchbox/searchboxcomponent.tsx